import { getCellsPositionFromCells } from "../components/cell/grid-cell.utils";
import { GridSizedViewUtils } from "./GridSizeViewUtils";
import { GridConfig } from "../modules/GridConfig";
import { CellRetrievalUtils } from "./CellRetrievalUtils";
import { GridCell } from "../components/cell/grid-cell";

/**
 * @description handles
 */
export class CellHighlightHandler {
    cellRetrieval = new CellRetrievalUtils();

    instanceId;

    constructor(instanceId) {
        this.instanceId = instanceId;
    }

    /**
     * @param {GridView} _self - GridViewCtx
     * @param {Object} lastHoveredCell - contains row and col of the last hovered cell
     * @param {GridCell[]} lastGeneratedTempCells - A array of temporary cells that were generated for the tempGrid last cicle
     * @description Handles Hover Animation. Gets called from inside AnimationFrame defined in gridView
     */
    handleHoverAnimation(_self, lastHoveredCell, lastGeneratedTempCells) {
        let pos;
        let multipleCellsHovered = null;
        let newlyTemporaryCellsCreated = [];
        const draggingContainer = _self.dragging && _self.dragging.hasOwnState && _self.dragging.width && _self.dragging.height;

        // clear custom func on previos temp cells
        if (lastGeneratedTempCells && lastGeneratedTempCells.length && !_self.dragging) {
            lastGeneratedTempCells.forEach(cell => {
                cell.clearSpecificCustomDrawingFunc("TEMP_BORDER_DRAWING");
                cell.draw();
            });
        }

        // Get curent location and affected cells
        if (_self.dragging) {
            const gridSizeUtils = new GridSizedViewUtils();
            pos = this.cellRetrieval.getCellPosition(_self.dragging, _self.temporary, _self.generatedGrid);
            pos = gridSizeUtils.validCellPosition(pos, _self.generatedGrid);
            if (draggingContainer && pos) {
                const hoveredCells = this.getAllHoveredCells(_self, pos);
                multipleCellsHovered = getCellsPositionFromCells(hoveredCells, _self.config);
            }
        }
        // Update previously hovered cells
        if (lastHoveredCell) {
            const cells = Array.isArray(lastHoveredCell) ? lastHoveredCell : [lastHoveredCell];
            cells.forEach(cellPos => {
                const stillHovered = (multipleCellsHovered || (pos ? [pos] : [])).indexOf(cellPosCheck => cellPosCheck.row === cellPos.row && cellPosCheck.col === cellPos.col) !== -1;
                if (!stillHovered) {
                    const cell = this.cellRetrieval.getCell(cellPos, _self.generatedGrid);
                    if (cell) this.updateDragHoverStatus(cell, false);
                }
            });
        }

        const currentCell = this.cellRetrieval.getCell(pos, _self.generatedGrid);
        // Hovering outside the permanentGrid or the dragged plugin does not find the permanent grid area from the current location
        const isContainerAndDoesntFit = this.cellIndependentContainerDoesntFit(_self.dragging, _self);
        let temporaryGridCreated = false;
        if (_self.dragging && (!currentCell || (currentCell && currentCell.state.temporary) || isContainerAndDoesntFit)) {
            if (isContainerAndDoesntFit) {
                // _self.createTemporaryGrid.bind(_self);
                const tempCells = _self.createTemporaryGrid(_self.dragging);
                lastGeneratedTempCells.forEach(cell => {
                    cell.clearSpecificCustomDrawingFunc("TEMP_BORDER_DRAWING");
                });
                newlyTemporaryCellsCreated.push(tempCells);
                temporaryGridCreated = true;
            } else if (!multipleCellsHovered) {
                const tempCells = this.highlightCurrentHoveredCell(lastHoveredCell, pos, _self);
                if (tempCells) {
                    lastGeneratedTempCells.forEach(cell => {
                        cell.clearSpecificCustomDrawingFunc("TEMP_BORDER_DRAWING");
                    });
                    newlyTemporaryCellsCreated.push(tempCells);
                    temporaryGridCreated = true;
                }
            }
        } else if (_self.dragging && pos && _self.temporary && currentCell && currentCell.state.temporary !== true) {
            // Hovering over a permanent cell. Clear temporary grid
            _self.stopLeftScroll = false;
            if (multipleCellsHovered) {
                multipleCellsHovered.forEach(atCell => {
                    const cellToSend = this.cellRetrieval.getCell(atCell, _self.generatedGrid);
                    if (cellToSend) {
                        this.hoveringOverPermanentCell(cellToSend, _self);
                    }
                });
            } else {
                this.hoveringOverPermanentCell(currentCell, _self);
            }
        }
        if (multipleCellsHovered) {
            this.isHoveredSideUpdate(multipleCellsHovered, draggingContainer, _self.generatedGrid);
        }
        if (temporaryGridCreated && newlyTemporaryCellsCreated) { // will check to see side cells of the temporary grid and draw a border on them
            newlyTemporaryCellsCreated = newlyTemporaryCellsCreated.flat(Infinity).filter(cell => cell instanceof GridCell);
            if (newlyTemporaryCellsCreated.length > 0) {
                this.getTemporaryOuterCells(newlyTemporaryCellsCreated);
            }
        }
        // highlight the current hovered cells
        const cellsToSend = (multipleCellsHovered || (pos ? [pos] : []));
        this.highlightCurrentHoveredCellsTwo(cellsToSend, _self);

        return { cells: multipleCellsHovered || pos || null, tempCells: newlyTemporaryCellsCreated };
    }

    isHoveredSideUpdate(cells, draggingContainer, grid) {

    }

    /**
     * @description Gets the cell that are on the side of the temporary grid
     * @param {GridCell[]} tempCells - Newly generated temporary cells
     * @returns { void }
     */
    getTemporaryOuterCells(tempCells) {
        const accumulator = {
            minWidth: { value: Infinity, cells: [] },
            maxWidth: { value: 0, cells: [] },
            minHeight: { value: Infinity, cells: [] },
            maxHeight: { value: 0, cells: [] }
        };
        tempCells.forEach((val) => {
            if (!val || (val && !val.layout)) {
                return;
            }
            if (val.layout.x === accumulator.minWidth.value) {
                accumulator.minWidth.cells.push(val);
            }
            if (val.layout.y === accumulator.minHeight.value) {
                accumulator.minHeight.cells.push(val);
            }
            if ((val.layout.x + val.layout.width) === accumulator.maxWidth.value) {
                accumulator.maxWidth.cells.push(val);
            }
            if ((val.layout.y + val.layout.height) === accumulator.maxHeight.value) {
                accumulator.maxHeight.cells.push(val);
            }

            if (val.layout.x < accumulator.minWidth.value) {
                accumulator.minWidth.value = val.layout.x;
                accumulator.minWidth.cells = [val];
            }
            if (val.layout.y < accumulator.minHeight.value) {
                accumulator.minHeight.value = val.layout.y;
                accumulator.minHeight.cells = [val];
            }
            const endX = (val.layout.x + val.layout.width);
            const endY = (val.layout.y + val.layout.height);
            if (endX > accumulator.maxWidth.value) {
                accumulator.maxWidth.value = endX;
                accumulator.maxWidth.cells = [val];
            }
            if (endY > accumulator.maxHeight.value) {
                accumulator.maxHeight.value = endY;
                accumulator.maxHeight.cells = [val];
            }
        });
        accumulator.minWidth.cells.forEach(cell => {
            const drawDashedLine = this.getDrawDashedLineFunc("LEFT");
            cell.setCustomDrawingFunc({ name: "TEMP_BORDER_DRAWING", func: drawDashedLine });
            cell.draw();
        });
        accumulator.maxWidth.cells.forEach(cell => {
            const drawDashedLine = this.getDrawDashedLineFunc("RIGHT");
            cell.setCustomDrawingFunc({ name: "TEMP_BORDER_DRAWING", func: drawDashedLine });
            cell.draw();
        });
        accumulator.minHeight.cells.forEach(cell => {
            const drawDashedLine = this.getDrawDashedLineFunc("TOP");
            cell.setCustomDrawingFunc({ name: "TEMP_BORDER_DRAWING", func: drawDashedLine });
            cell.draw();
        });
        accumulator.maxHeight.cells.forEach(cell => {
            const drawDashedLine = this.getDrawDashedLineFunc("BOTTOM");
            cell.setCustomDrawingFunc({ name: "TEMP_BORDER_DRAWING", func: drawDashedLine });
            cell.draw();
        });
    }

    /**
     * @description  Creates a closure with the side and gets called from inside the gridcell its set into
     * @param { String } side - The side to draw on
     * @returns {Function} - the function to be set inside a gridcell and to be called on draw
     */
    getDrawDashedLineFunc(side) {
        return function (cell) {
            cell.ctx.setLineDash([3]);
            cell.ctx.beginPath();
            if (side === "RIGHT") {
                cell.ctx.moveTo(cell.layout.x + cell.layout.width - 1, cell.layout.y + 1);
                cell.ctx.lineTo(cell.layout.x + cell.layout.width - 1, cell.layout.y + cell.layout.height - 1);
            }
            if (side === "LEFT") {
                cell.ctx.moveTo(cell.layout.x + 2, cell.layout.y + 2);
                cell.ctx.lineTo(cell.layout.x + 2, cell.layout.y + cell.layout.height - 2);
            }
            if (side === "TOP") {
                cell.ctx.moveTo(cell.layout.x + 2, cell.layout.y + 2);
                cell.ctx.lineTo(cell.layout.x + cell.layout.width - 2, cell.layout.y + 2);
            }
            if (side === "BOTTOM") {
                cell.ctx.moveTo(cell.layout.x + 1, cell.layout.y + cell.layout.height - 1);
                cell.ctx.lineTo(cell.layout.x + cell.layout.width - 1, cell.layout.y + cell.layout.height - 1);
            }
            cell.ctx.strokeStyle = "#4285F4";
            cell.ctx.stroke();
            cell.ctx.closePath();
            cell.ctx.setLineDash([]);
        };
    }

    /**
     * @description Highlights the provided cells parameter
     * @param { Object[] } cells -  {row, col} - Cell positions inside grid matrix to update styling on
     * @param { GridView } _self  - GridView instance
     * @returns { Void }
     */
    highlightCurrentHoveredCellsTwo(cells, _self) {
        cells.forEach((cellPos) => {
            const cell = this.cellRetrieval.getCell(cellPos, _self.generatedGrid);
            if (cell) this.updateDragHoverStatus(cell, true);
        });
    }

    /**
     * @description  Checks to see if the mouse moved to a new cell and generates the temporary grid
     * @param { Object } lastHoveredCell - {row, col} - Last hovered cell position inside grid matrix to update styling on
     * @param { Object } pos - {row, col} - cell position inside grid matrix to update styling on
     * @param { GridView } _self - GridView instance
     * @returns { GridCell[] }  - the temporary grid cells
     */
    highlightCurrentHoveredCell(lastHoveredCell, pos, _self) {
        if ((!lastHoveredCell && !pos) || (lastHoveredCell && pos)) {
            // make sure they are different cells before recreating the grid
            if (lastHoveredCell && pos) {
                const first = this.cellRetrieval.getCell(pos, _self.generatedGrid);
                const last = this.cellRetrieval.getCell(lastHoveredCell, _self.generatedGrid);
                if (first && last && first.layout.x === last.layout.x && first.layout.y === last.layout.y) {
                    return pos;
                }
            }
            const tempCells = _self.createTemporaryGrid(_self.dragging);
            return tempCells;
        }
    }

    /**
     * @description Checks if is a cell independent container plugin doesnt fit
     * @param { Object } dragVal - The object set in gridView that represents the current {x,y} mouse position + aditional properties in case of cell independent plugins
     * @param { GridView } _self - GridView instance
     * @returns { Boolean } - indicates if is a cell independent container plugin doesnt fit
     */
    cellIndependentContainerDoesntFit(dragVal, _self) {
        const hasDragValues = !!(dragVal && dragVal.hasOwnState && dragVal.width && dragVal.height);
        if (!dragVal || !hasDragValues) {
            return false;
        }
        const gridConfig = new GridConfig(this.instanceId);
        const newPosition = {
            x: dragVal.x - (dragVal.x % gridConfig.cellWidth),
            y: dragVal.y - (dragVal.y % gridConfig.cellHeight)
        };
        const coveredCells = _self.cellIndependentPluginHandler.getCoveredCells(newPosition, { width: dragVal.width, height: dragVal.height }, _self.generatedGrid, true);
        const toReturn = coveredCells.filter(cell => !cell || (cell && cell.state.temporary)).length > 0;
        return toReturn;
    }

    /**
     * @description Clears the temporary grid and cleansup the hover status on the permanent cell we are currently hovering
     * @param { GridCell } currentCell - the cell to perform de update on
     * @param { GridView } _self - GridView instance
     * @returns { void }
     */
    hoveringOverPermanentCell(currentCell, _self) {
        this.updateDragHoverStatus(currentCell, false);
        _self.clearTemporaryGrid();
    }

    /**
     * @description updates dragHover status on a cell and redraws it
     * @param { GridCell } cell - cell to update and draw
     * @param { Boolean } hoverVal - value to be set on the dragHover property
     * @retuns { void }
     */
    updateDragHoverStatus(cell, hoverVal) {
        cell.update({}, { dragHover: hoverVal });
        cell.clearCell();
        cell.draw();
    }

    /**
     * @description Looks for the covered cells by the cell independewnt plugin that is being dragged
     * @param { GridView } _self - GridView instance
     * @returns { GridCell[] } - covered cells array
     */
    getAllHoveredCells(_self) {
        if (!_self.dragging) return [];
        const size = { width: _self.dragging.width, height: _self.dragging.height };
        return _self.cellIndependentPluginHandler.getCoveredCells(_self.dragging, size, _self.generatedGrid, true);
    }
}
